// import { CommonModalListWrapStyle, CommonModalListItemStyle } from '@styles/base.style'
import styled from '@themes/theme'
import { CommonModalListItemStyle, CommonModalListWrapStyle } from '@styles/modal'

export const ChangeMatchWrap = styled.div`
  min-height: 188px;
  ${CommonModalListWrapStyle};
  background-color: ${props => props.theme.color.modalBg};
  padding: 9px 7px;
  .change-match-group {
    ${CommonModalListItemStyle};
    .match-block-header {
      padding: 0 8px;
      text-align: left;
      background: ${props => props.theme.color.modalBg};
      border-top: none;
      .tournament-date, .tournament-name, .country {
        color: ${props => props.theme.color.modalTxt};
        margin-right: 3px;
      }
      .sports-ico {
        width: 16px;
      }
      .league-ico {
        width: 16px;
      }
    }
    .change-match-list-wrap {
      display: flex;
      flex-direction: column;
      gap: 9px;
    }
    .change-match-list {
      position: relative;
      width: 100%;
      &--btn {
        z-index: 0;
        color: ${props => props.theme.color.modalTxt};
        background: ${props => props.theme.color.themeTxt};
        border-radius: 8px;
        overflow: hidden;
      }
      .score {
        font-size: ${props=>props.theme.font.title};
      }
      &:first-of-type {
        .line {
          display: none;
        }
      }
    }
  }
`
